<script>
import { markRaw } from 'vue';

import StuffFormSidebar from '../Part/StuffFormSidebar.vue';

export default {
    emits: ['onUpdate'],
    props: {
        room: {
            type: Object,
            required: true,
        },
        stuff: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            stuffFormSidebar: markRaw(StuffFormSidebar),

            data: {},
        };
    },
    computed: {
        cStuff() {
            return [...this.stuff]
        }
    },
    methods: {
        async destroy(id) {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    vm.$loading.on(['room_detail_stuff_delete', id].join('_'));

                    try {
                        var resp = await vm.$api.Stuff.delete({ id: id, is_permanent: 0 });
                        var data = resp.data;

                        vm.$emit('onUpdate');

                        vm.$flash.success(data.message);
                    } catch (err) {
                        vm.$flash.error(err.response.data.message);
                    }
                    vm.$loading.off(['room_detail_stuff_delete', id].join('_'));
                }
            });
        },
        async copy(id) {
            var vm = this;
            this.$loading.on(['room_detail_stuff_copy', id].join('_'));

            try {
                var resp = await this.$api.Stuff.copy(id);
                var data = resp.data;

                vm.$emit('onUpdate', true);

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off(['room_detail_stuff_copy', id].join('_'));
        },
        async rotate(id, direction) {
            var vm = this;
            this.$loading.on(['room_detail_stuff_rotate', id].join('_'));

            try {
                var params = {
                    id: id,
                    direction: direction,
                };

                await this.$api.Stuff.rotate(params);
                vm.$emit('onUpdate', true);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off(['room_detail_stuff_rotate', id].join('_'));
        },
        async layer(id, direction) {
            var vm = this;
            this.$loading.on(['room_detail_stuff_layer', id].join('_'));

            try {
                var params = {
                    id: id,
                    direction: direction,
                };

                await this.$api.Stuff.layer(params);
                vm.$emit('onUpdate', true);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off(['room_detail_stuff_layer', id].join('_'));
        },
        onRefreshStuff() {
            var vm = this;

            vm.$emit('onUpdate');
        }
    }
};
</script>

<template>
    <BRow class="mb-3">
        <BCol sm="auto">
            <div class="d-flex flex-wrap align-items-start gap-2">
                <btn-sidebar variant="success"
                    v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))"
                    :sidebar="stuffFormSidebar" :data="{ room: room, stuff: stuff }" :success="onRefreshStuff">
                    <i class="mdi mdi-plus-thick align-bottom me-1"></i> {{ $t('basic.btn.add') }}
                </btn-sidebar>
                <BButton type="button" variant="info"
                    @click="$router.push({ name: 'stuff', query: { room_id: room.id } })"
                    v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_list') && ($ac.hasAccessStore(room.store_id) || $ac.hasAccessBranch(room.branch_id))))">
                    <i class="mdi mdi-format-list-text align-bottom me-1"></i> {{ $t('basic.btn.more') }}
                </BButton>
            </div>
        </BCol>
    </BRow>
    <BRow>
        <BCol lg="12">
            <BCard no-body>
                <BCardBody>
                    <loading :loading="$loading.get('room_detail_stuff_create')" variant="dark" type="block">
                        <simplebar data-simplebar style="max-height: calc(100vh - 112px);" class="p-3">
                            <div class="table-responsive table-card position-relative">
                                <table class="table align-middle table-hover table-nowrap mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>{{ $t('stuff.label.ref_no') }}</th>
                                            <th>{{ $t('stuff.label.stuff_type') }}</th>
                                            <th>{{ $t('stuff.label.qty') }}</th>
                                            <th
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))">
                                                {{ $t('stuff.label.x') }}</th>
                                            <th
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))">
                                                {{ $t('stuff.label.y') }}</th>
                                            <th
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))">
                                                {{ $t('stuff.label.rotate') }}</th>
                                            <th style="width: 150px;"
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))">
                                                {{ $t('basic.label.action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in cStuff" :key="index">
                                            <td>
                                                <BDropdown variant="primary" size="sm" strategy="fixed" :toggle-class="{
                                                    'no-caret': $loading.get(['room_detail_stuff_layer', tr.id].join('_'))
                                                }"
                                                    :disabled="$loading.get(['room_detail_stuff_layer', tr.id].join('_'))">
                                                    <template #button-content
                                                        class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                        <loading
                                                            :loading="$loading.get(['room_detail_stuff_layer', tr.id].join('_'))"
                                                            variant="light" type="button">
                                                            {{ tr.number }}
                                                        </loading>
                                                    </template>
                                                    <BDropdownItem href="#" variant="primary" size="sm"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))"
                                                        @click.prevent="layer(tr.id, 'up')"><i
                                                            class="mdi mdi-arrow-up fs-16 me-1"></i>{{
                                                                $t('stuff.btn.layer_up') }}</BDropdownItem>
                                                    <BDropdownItem href="#" variant="primary" size="sm"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))"
                                                        @click.prevent="layer(tr.id, 'down')"><i
                                                            class="mdi mdi-arrow-down fs-16 me-1"></i>{{
                                                                $t('stuff.btn.layer_down') }}</BDropdownItem>
                                                </BDropdown>
                                                <span
                                                    v-if="!($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">{{
                                                        tr.number }}</span>
                                            </td>
                                            <td>
                                                {{ tr.ref_no }}
                                                <div v-if="tr.ref_no_external">
                                                    <BBadge variant="info">{{ tr.ref_no_external }}</BBadge>
                                                </div>
                                            </td>
                                            <td>{{ tr.stuff_type }}</td>
                                            <td>
                                                <span class="badge bg-danger-subtle text-danger"
                                                    v-if="tr.is_static == 1">{{
                                                        $t('stuff.label.static')
                                                    }}</span>
                                                <span v-if="tr.is_static == 0">{{ tr.qty }}</span>
                                            </td>
                                            <td
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">
                                                <span class="badge border border-info text-info sm">{{ tr.x
                                                }}</span>
                                            </td>
                                            <td
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">
                                                <span class="badge border border-info text-info sm">{{ tr.y
                                                }}</span>
                                            </td>
                                            <td
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">
                                                <BDropdown variant="primary" size="sm" strategy="fixed" :toggle-class="{
                                                    'no-caret': $loading.get(['room_detail_stuff_rotate', tr.id].join('_'))
                                                }"
                                                    :disabled="$loading.get(['room_detail_stuff_rotate', tr.id].join('_'))">
                                                    <template #button-content
                                                        class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                        <loading
                                                            :loading="$loading.get(['room_detail_stuff_rotate', tr.id].join('_'))"
                                                            variant="light" type="button">
                                                            {{ tr.rotation }} °
                                                        </loading>
                                                    </template>
                                                    <BDropdownItem href="#" variant="primary" size="sm"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create')))"
                                                        @click.prevent="rotate(tr.id, 'left')"><i
                                                            class="mdi mdi-rotate-left fs-16"></i>{{
                                                                $t('stuff.btn.rotate_left') }}</BDropdownItem>
                                                    <BDropdownItem href="#" variant="primary" size="sm"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create')))"
                                                        @click.prevent="rotate(tr.id, 'right')"><i
                                                            class="mdi mdi-rotate-right fs-16"></i>{{
                                                                $t('stuff.btn.rotate_right') }}</BDropdownItem>
                                                </BDropdown>
                                            </td>
                                            <td
                                                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">
                                                <BDropdown variant="primary" no-caret size="sm" strategy="fixed"
                                                    :toggle-class="{
                                                        'no-caret': $loading.get(['room_detail_stuff_copy', tr.id].join('_')) ||
                                                            $loading.get(['room_detail_stuff_delete', tr.id].join('_'))
                                                    }" :disabled="$loading.get(['room_detail_stuff_copy', tr.id].join('_')) ||
                                                        $loading.get(['room_detail_stuff_delete', tr.id].join('_'))">
                                                    <template #button-content
                                                        class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                        <loading
                                                            :loading="$loading.get(['room_detail_stuff_copy', tr.id].join('_')) ||
                                                                $loading.get(['room_detail_stuff_delete', tr.id].join('_'))"
                                                            variant="light" type="button">
                                                            {{ $t('basic.btn.action') }}
                                                        </loading>
                                                    </template>
                                                    <BDropdownItem @click.prevent="copy(tr.id)" variant="primary"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))">
                                                        <i class="mdi mdi-content-copy fs-16"></i> {{
                                                            $t('stuff.btn.copy') }}
                                                    </BDropdownItem>
                                                    <btn-sidebar type="group" variant="warning"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(tr.store_id)))"
                                                        :sidebar="stuffFormSidebar" :data="{ room: room, stuff: stuff }"
                                                        :success="onRefreshStuff"
                                                        v-model="cStuff[index]">
                                                        <i class="mdi mdi-pencil-outline fs-16"></i> {{
                                                            $t('basic.btn.edit') }}
                                                    </btn-sidebar>
                                                    <BDropdownItem @click.prevent="destroy(tr.id)" variant="danger"
                                                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_delete') && $ac.hasAccessStore(tr.store_id)))">
                                                        <i class="mdi mdi-eraser fs-16"></i> {{
                                                            $t('basic.btn.delete') }}
                                                    </BDropdownItem>
                                                </BDropdown>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </simplebar>
                    </loading>
                </BCardBody>
            </BCard>
        </BCol>
    </BRow>
</template>